import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import moment from "moment-timezone";
import { Alert, Icon, Table } from "antd";
import { withNamespaces } from "react-i18next";

import isAuthenticated from "../../utils/isAuthenticated";
import { getDocumentVersionsRequest } from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import classes from "../FinancePricesEditor/FinancePricesEditor.css";
import {
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import FileLink from "../../components/FileLink/FileLink";

class DocumentVersions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      versions: [],
      isLoading: true,
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getDocumentVersionsRequest(this.props.id);
      this.setState({ versions: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }

      this.setState({
        errorMessage: this.props.i18n.t("Something went wrong"),
      });
      console.log(e);
    }

    this.setState({
      isLoading: false,
    });
  }

  render() {
    const { errorMessage, isLoading, versions } = this.state;

    const columns = [
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("Name"),
        render: (val) => <span>{val}</span>,
      },
      {
        dataIndex: "created",
        key: "created",
        title: this.props.i18n.t("Created At"),
        render: (val) => (
          <span>{moment(val).format("DD MMM YYYY, HH:mm")} UTC</span>
        ),
      },
      {
        dataIndex: "created_by_user",
        key: "created_by_user",
        title: this.props.i18n.t("Created by"),
        render: (val) => <span>{get(val, 'username')}</span>,
      },
      {
        dataIndex: "version",
        key: "version",
        title: this.props.i18n.t("Version"),
        render: (val) => <span>{val}</span>,
      },
      {
        dataIndex: "content_type_name",
        key: "content_type_name",
        title: this.props.i18n.t("Content type"),
        render: (val) => <span>{val}</span>,
      },
      {
        dataIndex: "url",
        key: "url",
        title: this.props.i18n.t("Link"),
        render: (val) => <FileLink url={val} />,
      },
    ];

    return (
      <div>
        <h4 className="headline">{this.props.i18n.t("NamespaceDocumentsVersions:Versions of")} {this.props.name}</h4>

        {isLoading && <Icon type="loading" />}

        {!isLoading && versions.length === 0 && <div>{this.props.i18n.t("NamespaceDocumentsVersions:No records")}.</div>}

        {versions && versions.length > 0 && (
          <div>
            <Table
              columns={columns}
              dataSource={versions}
              loading={isLoading}
              rowKey="id"
              pagination={false}
            />
          </div>
        )}

        {errorMessage && (
          <Alert
            type="error"
            message={errorMessage}
            className={classes.alert}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DocumentVersions))
);



// WEBPACK FOOTER //
// ./src/containers/DocumentsEditor/DocumentsVersions.js